/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ReleaseTypeEnum = 'GA' | 'EA';

export const ReleaseTypeEnum = {

    GA: 'GA' as ReleaseTypeEnum,

    EA: 'EA' as ReleaseTypeEnum
};

